import {priority, wcfclient} from '@priority-software/priority-proto-api/lib';
import {
    getFormName,
    getParentFormName,
    getTextFormName
} from '../../../_shared/GWTBridge/invoke/recon';
import {getAdditionalProps} from '../core/loginProps';
import {callServer} from '../core/server';
import {ServerMethods} from '../core/constants';
import {fetchMax} from '../../../features/Form/consts/grid';
import {startForm, endForm, fetchColumns} from '../../form/form';

export const fetchReconText = async () => {
    const name = getFormName();
    const parentName = getParentFormName();

    const form = await startForm(parentName);
    const cols = await fetchColumns(form.Session);

    const rows = await callServer(
        wcfclient.recordsFetch,
        new priority.netitems.form.FetchRq({
            Session: form.Session,
            Properties: getAdditionalProps(),
            Top: fetchMax,
            Filters: [
                {
                    Condition: [
                        {
                            ColumnID: cols.Columns[0]?.ID,
                            Operator: priority.netitems.shared.ComparisonOperator.Eq,
                            Values: ['Y']
                        }
                    ]
                }
            ]
        }),
        ServerMethods.FetchRq
    );

    await callServer(
        wcfclient.subform,
        new priority.netitems.form.SubformRq({
            Properties: getAdditionalProps(),
            Fname: name,
            Session: form.Session,
            Keys: rows.Records[0].Fields
        }),
        ServerMethods.SubformRq
    );

    const textformname = getTextFormName();
    const subformrows = await callServer(
        wcfclient.recordsFetch,
        new priority.netitems.form.FetchRq({
            Session: form.Session,
            Properties: getAdditionalProps(),
            Top: fetchMax,
            Filters: [
                {
                    Condition: [
                        {
                            ColumnID: cols.Columns[0]?.ID,
                            Operator: priority.netitems.shared.ComparisonOperator.Eq,
                            Values: ['*']
                        }
                    ]
                }
            ]
        }),
        ServerMethods.FetchRq
    );

    await callServer(
        wcfclient.subform,
        new priority.netitems.form.SubformRq({
            Properties: getAdditionalProps(),
            Fname: textformname,
            Session: form.Session,
            Keys: subformrows.Records[0]?.Fields
        }),
        ServerMethods.SubformRq
    );

    const htmlRes = await wcfclient.htmlFetch(
        new priority.netitems.form.HtmlFetchRq({
            Session: form.Session,
            Properties: getAdditionalProps()
        })
    );

    await endForm(form.Session);
    await endForm(form.Session);
    await endForm(form.Session);

    return htmlRes;
};

export const saveReconText = async (htmlContent: string) => {
    const name = getFormName();
    const parentName = getParentFormName();

    const form = await startForm(parentName);
    const cols = await fetchColumns(form.Session);

    const rows = await callServer(
        wcfclient.recordsFetch,
        new priority.netitems.form.FetchRq({
            Session: form.Session,
            Properties: getAdditionalProps(),
            Top: fetchMax,
            Filters: [
                {
                    Condition: [
                        {
                            ColumnID: cols.Columns[0]?.ID,
                            Operator: priority.netitems.shared.ComparisonOperator.Eq,
                            Values: ['Y']
                        }
                    ]
                }
            ]
        }),
        ServerMethods.FetchRq
    );

    await callServer(
        wcfclient.subform,
        new priority.netitems.form.SubformRq({
            Properties: getAdditionalProps(),
            Fname: name,
            Session: form.Session,
            Keys: rows.Records[0].Fields
        }),
        ServerMethods.SubformRq
    );

    const textformname = getTextFormName();
    const subformrows = await callServer(
        wcfclient.recordsFetch,
        new priority.netitems.form.FetchRq({
            Session: form.Session,
            Properties: getAdditionalProps(),
            Top: fetchMax,
            Filters: [
                {
                    Condition: [
                        {
                            ColumnID: cols.Columns[0]?.ID,
                            Operator: priority.netitems.shared.ComparisonOperator.Eq,
                            Values: ['*']
                        }
                    ]
                }
            ]
        }),
        ServerMethods.FetchRq
    );

    await callServer(
        wcfclient.subform,
        new priority.netitems.form.SubformRq({
            Properties: getAdditionalProps(),
            Fname: textformname,
            Session: form.Session,
            Keys: subformrows.Records[0].Fields
        }),
        ServerMethods.SubformRq
    );

    await wcfclient.htmlSave(
        new priority.netitems.form.HtmlSaveRq({
            Session: form.Session,
            Properties: getAdditionalProps(),
            Content: htmlContent
        })
    );

    await endForm(form.Session);
    await endForm(form.Session);
    await endForm(form.Session);
};
